import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { AuditResult } from '@/lib/schemas';

interface ScoreCardProps {
  result: AuditResult;
  companyName: string;
}

export function ScoreCard({ result, companyName }: ScoreCardProps) {
  const progressPercentage = (result.score / 60) * 100;
  
  const getScoreColor = (score: number) => {
    if (score <= 20) return '#dc2626'; // Red for urgent
    if (score <= 40) return '#F47725'; // Brand orange for amber
    return '#94CD39'; // Brand green for good
  };
  
  const getBadgeClasses = (score: number) => {
    if (score <= 20) return 'bg-red-600 text-white';
    if (score <= 40) return 'bg-brand-orange text-white';
    return 'bg-brand-green text-white';
  };

  return (
    <Card className="mb-6 border-0 shadow-xl bg-white/90 backdrop-blur-sm">
      <CardHeader className="pb-6">
        <CardTitle className="text-2xl text-center font-bold text-black">
          Audit Results for {companyName}
        </CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-6">
        <div className="space-y-3">
          <div className="text-6xl font-bold" style={{ color: getScoreColor(result.score) }}>
            {result.score}/60
          </div>
          <div className="text-base text-gray-600 font-medium">
            <a href="https://cal.com/advissoftware/digitalisation-audit-consultation" 
            target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:text-brand-orange/80">
              Book a Free 15-min Walkthrough of Your Audit Results</a>
          </div>
          <Progress value={progressPercentage} className="w-full h-3 rounded-full" />
          <div className="text-base text-gray-600 font-medium">{Math.round(progressPercentage)}% Digital Efficiency Score</div>
        </div>
        
        <div className="space-y-3">
          <div className={`inline-flex items-center rounded-full px-4 py-2 text-lg font-semibold shadow-lg ${getBadgeClasses(result.score)}`}>
            {result.zone}
          </div>
          <p className="text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            {result.summary}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}